import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
export function Guarantee() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="w-full bg-white py-4" data-id="element-103">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-104">
        <div className="max-w-4xl mx-auto" data-id="element-105">
          <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-4 py-2 border border-brand-violet/20 rounded-sm bg-brand-cream/30 hover:bg-brand-cream/50 transition-colors" data-id="element-106">
            <span className="text-sm font-serif text-[#5B3273]" data-id="element-107">
              Garantía 30 días de Autoconocimiento
            </span>
            <ChevronRight className={`w-4 h-4 text-brand-violet transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`} data-id="element-108" />
          </button>

          <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mt-2' : 'max-h-0 opacity-0'}`} data-id="element-109">
            <div className="px-4 py-3 text-sm text-brand-light leading-relaxed bg-brand-cream/20 rounded-sm border border-brand-violet/10" data-id="element-110">
              Probalo durante 30 días sin riesgo. Si en ese tiempo sentís que
              Viaje a tu Interior no te ayudó a mirar hacia dentro, entenderte
              mejor o conectar con vos misma, podés pedir la devolución total de
              tu dinero. Sin preguntas. Porque la misión de este journal es
              acompañarte de verdad en tu proceso 💜
            </div>
          </div>
        </div>
      </div>
    </div>;
}